import AppliedFilterMarkComponent from "./components/applied-filter-mark";
import UlComponent from "./components/ul";
import FilterController from "./controllers/filter";
import ItemsController from "./controllers/items";
import {createButton} from "./create/create-button";
import {createDiv} from "./create/create-div";
import {createList} from "./create/create-list";
import {createListItem} from "./create/create-list-item";
import {createParagraph} from "./create/create-paragraph";
import {createSpan} from "./create/create-span";
import {createSvg} from "./create/create-svg";
import {renderPaginator} from "./render-paginator";
import {getItems} from "./require/get-items";
import {getCookie} from "./utils/get-cookie";
import {getCurrentFilter} from "./utils/get-current-filter";
import {getFilter} from "./utils/get-filter";
import {getProductNumeralEnding} from "./utils/get-numeral-ending";
import {getUrlSearch} from "./utils/get-url-search";
import {isEmptyArray} from "./utils/is-empty-array";
import {isEmptyObject} from "./utils/is-empty-object";
import {RenderPosition, render, render as renderComponent} from "./utils/render";
import {setPageUrl} from "./utils/set-page-url";
import {setCookie} from "./utils/set-cookie";
import {renderShowMoreButton} from "./utils/render-show-more-button";
import {renderAccessories} from "./render-accessories";


export const renderProductsPage = (namePage = ``, shopInfoData, filterList, itemList) => {
  const productListPageElement = document.querySelector(`.product-list-page`);

  const setTitle = () => {
    const titleElement = productListPageElement.querySelector(`.product-list-page__title`);
    titleElement.textContent = itemList.title;
  };

  const setCountTitle = (count) => {
    const countElement = productListPageElement.querySelector(`.product-list-page__count`);
    if (namePage === `search`) {
      countElement.innerHTML = `Найдено ${getProductNumeralEnding(count)}`;
    } else {
      countElement.innerHTML = getProductNumeralEnding(count);
    }
  };

  const setFilterUrl = () => {
    const results = [];

    Object.keys(filter)
    .filter((alias) => alias !== `parent` && alias !== `name` && alias !== `promo`)
    .forEach((alias) => {
      if (filter[alias].type === `range`) {
        if (filter[alias].min || filter[alias].max) {
          results.push(`${alias}_${filter[alias].min}-${filter[alias].max}`);
        }

        filter[alias].values.forEach((value) => results.push(`${alias}_${value.id}`));
      }

      if (filter[alias].type === `list`) {
        filter[alias].values.forEach((value) => results.push(`${alias}_${value.id}`));
      }
    });

    const params = new URLSearchParams(document.location.search.substring(1));

    if (isEmptyArray(results)) {
      params.delete(`f`);
    } else {
      params.set(`f`, results.join(`,`));
    }
    const url = `${window.location.origin}${window.location.pathname}?${params.toString()}`;

    // const url = getFilterUrl(results);
    window.history.pushState(null, null, url);
  };

  const clearFilter = () => {
    Object.keys(filter)
        .filter((alias) => alias !== `parent` && alias !== `name` && alias !== `promo`)
        .forEach((alias) => delete filter[alias]);
    filterController.clear();
  };


  const filter = getCurrentFilter(filterList);

  const filterElement = document.querySelector(`.filter`);

  const filterController = new FilterController({
    container: filterElement,
    filter,
    filterList,
    onChangeData: (filter) => {
      activePage2 = 1;
      setPageUrl(activePage2);
      getItemsData();
      setFilterUrl();

      onCloseFilterHandler();
    }
  });

  const onOpenFilterHandler = () => {
    productListPageElement.dataset.isFilterShow = true;
    document.querySelector(`body`).classList.add(`overflowHidden`);
  };

  const onCloseFilterHandler = () => {
    productListPageElement.dataset.isFilterShow = false;
    document.querySelector(`body`).classList.remove(`overflowHidden`);
  };

  const openFilterButton = productListPageElement.querySelector(`.product-list-page__filterButton`);
  if (openFilterButton) {
    openFilterButton.addEventListener(`click`, onOpenFilterHandler);
  }

  const closeFilterButton = productListPageElement.querySelector(`.filter__closeButton`);
  if (closeFilterButton) {
    closeFilterButton.addEventListener(`click`, onCloseFilterHandler);
  }

  const overlayFilterButton = productListPageElement.querySelector(`.filter__overlay`);
  if (overlayFilterButton) {
    overlayFilterButton.addEventListener(`click`, onCloseFilterHandler);
  }

  const applyFilterButton = productListPageElement.querySelector(`.filter__applyButton`);
  if (applyFilterButton) {
    applyFilterButton.addEventListener(`click`, onCloseFilterHandler);
  }

  // filter -->


  filter.parent = itemList.parent || undefined;
  filter.name = itemList.filter ? itemList.filter.name : ``;
  filter.promo = itemList.filter ? itemList.filter.promo : ``;

  const setActiveSort = (data) => {
    sort = data;
    const params = new URLSearchParams(document.location.search.substring(1));

    params.set(`sort`, sort);
    const url = `${window.location.origin}${window.location.pathname}?${params.toString()}`;

    window.history.pushState(null, null, url);
  };

  let sort = itemList.order_by;
  if (sort) {
    const currentSortButton = productListPageElement.querySelector(`.sort__button[data-sort-id="${sort}"]`);
    currentSortButton.classList.add(`sort__button--active`);
  }

  // сортировка
  const sortElement = productListPageElement.querySelector(`.sort`);
  const sortButtons = sortElement.querySelectorAll(`.sort__button`);

  const onSortChoiceHandler = (evt) => {
    const button = evt.target;
    const activeButton = sortElement.querySelector(`.sort__button--active`);

    activeButton.classList.remove(`sort__button--active`);
    activeButton.removeEventListener(`click`, onSortListShowHandler);
    activeButton.addEventListener(`click`, onSortChoiceHandler);

    button.classList.add(`sort__button--active`);
    button.removeEventListener(`click`, onSortChoiceHandler);
    button.addEventListener(`click`, onSortListShowHandler);

    sort = button.dataset.sortId;
    sortElement.dataset.isShow = false;

    activePage2 = 1;
    setPageUrl(activePage2);
    setActiveSort(sort);
    getItemsData();
  };

  const onSortListShowHandler = () => {
    sortElement.dataset.isShow = true;
  };

  Array.from(sortButtons).forEach((button) => {
    if (button.classList.contains(`sort__button--active`)) {
      button.addEventListener(`click`, onSortListShowHandler);
    } else {
      button.addEventListener(`click`, onSortChoiceHandler);
    }
  });

  // количество на лист
  const countPerPageElement = productListPageElement.querySelector(`.countPerPage`);
  const countPerPageButton = countPerPageElement.querySelector(`.countPerPage__button`);
  const countPerPageCountElement = countPerPageElement.querySelector(`.countPerPage__count`);
  const countPerPageItemElement = countPerPageElement.querySelectorAll(`.countPerPage__item`);

  let countPerPage = getCookie(`items_on_page`);
  if (!countPerPage || countPerPage === `undefined`) {
    countPerPage = `48`;
  }

  countPerPageCountElement.textContent = countPerPage;
  countPerPageElement.dataset.count = countPerPage;

  const onDocumentClickHandler = (evt) => {
    const target = evt.target;
    const isContains = countPerPageElement.contains(target);

    if (isContains) {
      return;
    }
    countPerPageElement.dataset.isShow = false;

    document.removeEventListener(`click`, onDocumentClickHandler);
  };

  countPerPageButton.addEventListener(`click`, () => {
    countPerPageElement.dataset.isShow = true;

    document.addEventListener(`click`, onDocumentClickHandler);
  });

  Array.from(countPerPageItemElement).forEach((item) => {
    item.addEventListener(`click`, () => {
      countPerPage = item.dataset.count;
      countPerPageCountElement.textContent = countPerPage;
      countPerPageElement.dataset.isShow = false;
      countPerPageElement.dataset.count = countPerPage;

      setCookie(`items_on_page`, countPerPage);
      activePage2 = 1;
      setPageUrl(activePage2);
      getItemsData();
    });
  });


  // отрисовка карточек
  const productItemsElement = productListPageElement.querySelector(`.product-list-page__items`);
  const appliedFilterList = productListPageElement.querySelector(`.product-list-page__appliedFilterList`);
  const categoriesElement = productListPageElement.querySelector(`.categories__wrap`);

  const renderItems = (items, isAdd = false) => {
    if (!isAdd) {
      productItemsElement.innerHTML = ``;
      window.scrollTo(0, 0);
    }
    let listElement = productItemsElement.querySelector(`.items`);
    if (!listElement) {
      const listComponent = new UlComponent(`items items--${activeView}`);
      render(productItemsElement, listComponent.getElement(), RenderPosition.BEFOREEND);
      listElement = listComponent.getElement();
    }

    new ItemsController({
      items,
      shopInfoData
    }).render(listElement);
  };

  const renderAppliedFilter = () => {
    appliedFilterList.innerHTML = ``;

    Object.keys(filter)
    .filter((alias) => alias !== `parent` && alias !== `group` && alias !== `name` && alias !== `promo`)
    .forEach((alias) => {
      if (filter[alias].type === `range`) {
        if (filter[alias].min || filter[alias].max) {
          const startText = filter[alias].min ? `от ${filter[alias].min} ` : ``;
          const finishText = filter[alias].max ? `до ${filter[alias].max}` : ``;
          const text = `${filter[alias].title}: ${startText} ${finishText}`;

          const component = new AppliedFilterMarkComponent({
            text,
          });

          component.setClickHandler(() => {
            filter[alias].min = ``;
            filter[alias].max = ``;
            if (!filter[alias].min && !filter[alias].max && isEmptyArray(!filter[alias].values)) {
              delete filter[alias];
            }

            activePage2 = 1;
            setPageUrl(activePage2);
            getItemsData();
            setFilterUrl();
          });

          renderComponent(appliedFilterList, component.getElement(), RenderPosition.BEFOREEND);
        }

        if (!isEmptyArray(filter[alias].values)) {
          filter[alias].values
          .filter((value) => value.title)
          .forEach((value) => {
            const component = new AppliedFilterMarkComponent({
              text: `${filter[alias].title}: ${value.title}`,
            });

            component.setClickHandler(() => {
              const id = value.id;

              if (alias in filter) {
                const index = filter[alias].values.findIndex((it) => it.id === id);

                if (index !== -1) {
                  filter[alias].values.splice(index, 1);
                }

                if (isEmptyArray(filter[alias])) {
                  delete filter[alias];
                }
              }

              activePage2 = 1;
              setPageUrl(activePage2);
              getItemsData();
              setFilterUrl();
            });

            renderComponent(appliedFilterList, component.getElement(), RenderPosition.BEFOREEND);
          });
        }

      }

      if (filter[alias].type === `list`) {
        filter[alias].values
        .filter((value) => value.title)
        .forEach((value) => {
          const component = new AppliedFilterMarkComponent({
            text: value.title,
          });

          component.setClickHandler(() => {
            const id = value.id;

            if (alias in filter) {
              const index = filter[alias].values.findIndex((it) => it.id === id);

              if (index !== -1) {
                filter[alias].values.splice(index, 1);
              }

              if (isEmptyArray(filter[alias])) {
                delete filter[alias];
              }
            }

            activePage2 = 1;
            setPageUrl(activePage2);
            getItemsData();
            setFilterUrl();
          });

          renderComponent(appliedFilterList, component.getElement(), RenderPosition.BEFOREEND);
        });
      }
    });
  };

  const renderCategories = (categories = {}) => {
    const deactivateCategoriesButton = () => {
      categoriesListElement.querySelectorAll(`.categories__button[data-active="true"]`)
      .forEach((elem) => {
        elem.dataset.active = `false`;
      });
    };

    categoriesElement.innerHTML = ``;

    if (isEmptyObject(categories)) {
      return;
    }

    const wrapElement = createDiv(`categories__content`);
    categoriesElement.append(wrapElement);

    const titleElement = createParagraph(`categories__title`, `Найдено в категориях`);
    wrapElement.append(titleElement);

    const categoriesListElement = createList(`categories__list`);
    wrapElement.append(categoriesListElement);

    const filterUrl = getUrlSearch(`f`);

    const filterGroups = filterUrl ? filterUrl.split(`,`) : [];

    Object.keys(categories)
    .forEach((it) => {
      const category = categories[it];

      const liItemElement = createListItem(`categories__item`);
      categoriesListElement.append(liItemElement);

      const buttonElement = createButton(category.title, `categories__button`);
      buttonElement.dataset.active = filterGroups.includes(`group_${category.id}`);
      liItemElement.append(buttonElement);
      const svg = createSvg(`categories__buttonIcon`, `10`, `10`, `sienge/img/sprite.svg#close`);
      buttonElement.append(svg);

      buttonElement.addEventListener(`click`, () => {
        if (buttonElement.dataset.active === `true`) {
          deactivateCategoriesButton();
          clearFilter();

          activePage2 = 1;
          setPageUrl(activePage2);
          getItemsData();
          setFilterUrl();
        } else {
          deactivateCategoriesButton();
          clearFilter();

          buttonElement.dataset.active = `true`;

          const newValue = {id: category.id, title: ``};

          filter[`group`] = {
            type: `list`,
            values: [newValue]
          };

          activePage2 = 1;
          setPageUrl(activePage2);
          getItemsData();
          setFilterUrl();
        }
      });

      if (category.count) {
        const categoryCountElement = createSpan(`categories__count`, `<sup>${category.count}</sup`);
        liItemElement.append(categoryCountElement);
      }
    });
  };

  const activeListView = () => {
    listViewButton.classList.add(`product-list-page__viewButton--active`);
    tileViewButton.classList.remove(`product-list-page__viewButton--active`);
    if (productItemsElement.querySelector(`.items`)) {
      productItemsElement.querySelector(`.items`).classList.add(`items--list`);
      productItemsElement.querySelector(`.items`).classList.remove(`items--tile`);
    }

    // productListElement.classList.add(`product-list--list`);
    // productListElement.classList.remove(`product-list--tile`);
  };

  const activeTileView = () => {
    tileViewButton.classList.add(`product-list-page__viewButton--active`);
    listViewButton.classList.remove(`product-list-page__viewButton--active`);

    if (productItemsElement.querySelector(`.items`)) {
      productItemsElement.querySelector(`.items`).classList.add(`items--tile`);
      productItemsElement.querySelector(`.items`).classList.remove(`items--list`);
    }
  };

  const listViewButton = productListPageElement.querySelector(`.product-list-page__viewButton--list`);
  const tileViewButton = productListPageElement.querySelector(`.product-list-page__viewButton--tile`);

  const activeView = window.localStorage[`viewProductList`] ? window.localStorage[`viewProductList`] : `tile`;

  if (activeView === `list`) {
    activeListView();
  }

  if (activeView === `tile`) {
    activeTileView();
  }

  if (listViewButton) {
    listViewButton.addEventListener(`click`, () => {
      activeListView();
      window.localStorage[`viewProductList`] = `list`;
    });
  }

  if (tileViewButton) {
    tileViewButton.addEventListener(`click`, () => {
      activeTileView();
      window.localStorage[`viewProductList`] = `tile`;
    });
  }

  // if (window.location.pathname !== `/search`) {
  //   const titleElement = productListPageElement.querySelector(`.product-list-page__title`);
  //   titleElement.textContent = itemList.title;
  // }

  setTitle(itemList.count);
  setCountTitle(itemList.count);


  // пагинатор
  const paginatorElement = productListPageElement.querySelector(`.paginator`);
  let activePage2 = +getUrlSearch(`p`) || 1;

  // кнопка Показать еще
  const showAllElement = productListPageElement.querySelector(`.product-list-page__show-all`);

  const onShowMoreButtonCLickHandler = () => {
    activePage2 = +activePage2 + 1;
    setPageUrl(activePage2);
    getItemsData(true);
  };

  renderCategories(itemList.groups);
  renderAppliedFilter();
  renderItems(itemList.items);
  filterController.render();
  renderShowMoreButton(showAllElement, +countPerPage, +itemList.count, +activePage2, onShowMoreButtonCLickHandler);
  renderPaginator(paginatorElement, +itemList.page_count, activePage2, (page) => {
    activePage2 = page;
    setPageUrl(activePage2);
    getItemsData();
  });

  Object.values(additionList).forEach((addition) => {
    renderAccessories(productListPageElement, `product-list-page`, addition);
  });

  // запрос на получение товаров
  const getItemsData = (isAdd = false) => {
    productItemsElement.dataset.state = `loader`;
    getItems({
      filter: getFilter(filter),
      sort,
      activePage: activePage2,
      resolveHandler: (response) => {
        renderItems(response.items, isAdd);
        productItemsElement.dataset.state = `list`;

        setCountTitle(response.count);

        filterController.updateFilterList(response.filter_list);
        renderAppliedFilter();
        renderCategories(response.groups);
        renderShowMoreButton(showAllElement, +countPerPage, +response.count, +activePage2, onShowMoreButtonCLickHandler);
        renderPaginator(paginatorElement, +response.page_count, activePage2, (page) => {
          activePage2 = page;
          setPageUrl(activePage2);
          getItemsData();
        });
      }
    });
  };

  const clearFilterButton = productListPageElement.querySelector(`.filter__clearButton`);
  if (clearFilterButton) {
    clearFilterButton.addEventListener(`click`, () => {
      clearFilter();

      activePage2 = 1;
      setPageUrl(activePage2);
      getItemsData();
      setFilterUrl();
    });
  }
};
